<template>
  <div id="presentation" class="fixed-content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xs-12">
          <carousel :interval="5000" class="home-carousel" v-if="sc">
            <slide v-for="c in sc.slides" :key="`${c.title}`">
              <div>
                <div class="img-container">
                  <img :src="require(`@/assets/${c.img}`)"
              class="img-responsive">
                </div>
                <div class="carousel-caption">
                  <h3 v-html="c.title"></h3>
                  <ul v-if="c.dots" class="text-justify">
                    <li v-for="l in c.dots" :key="`${l.key}-dot`"
                        v-html="l.html.join('')">
                    </li>
                  </ul>
                  <div v-if="c.rlink">
                    <router-link v-if="c.rlink" :to="`${c.rlink}`" tag="div">
                      <btn :type="c.btnStyle ? c.btnStyle : 'primary'"
                           v-html="`${c.rlinkTitle == null ? 'En savoir plus' : c.rlinkTitle}`">
                      </btn>
                    </router-link>
                  </div>
                  <div v-if="c.link">
                    <a class="btn btn-primary" :href="c.link" target="_blank">
                      En savoir plus
                    </a>
                  </div>
                </div>
              </div>
            </slide>
            <template slot="indicators" slot-scope="props">
              <div class="carousel-indicators-container">
                <ol class="carousel-indicators custom-carousel-indicators">
                  <li v-for="(slide, index) in sc.slides"
                      :key="`slide-indicator-${index}`"
                      :class="{active: index === props.activeIndex}"
                      @click="props.select(index)">
                    <strong>
                      {{ index + 1 }}
                    </strong>
                  </li>
                </ol>
              </div>
            </template>
          </carousel>
        </div>
      </div>
    </div>
    <page-section type="dark-base">
      <div class="row">
        <div class="col-xs-12 col-md-6 col-lg-4">
          <home-panel :background="require('@/assets/bacteria.jpg')">
            <div class="row">
              <div class="col-xs-12">
                <h3><p>Surveillance</p></h3>
                <p class="text-justify">
                  La <strong>page de présentation</strong> de la surveillance est
                  en cours de mise à jour avec le <strong>déroulement et les protocoles
                  2026</strong>.
                </p>
              </div>
              <div class="col-xs-6 col-sm-12 col-lg-8">
                <p>
                  <btn type="primary"
                       block
                       @click="$router.push('/program?target=presentation')">
                    La surveillance 2026
                  </btn>
                </p>
              </div>
              <div class="col-xs-12">
                <p class="text-justify">
                  Rendez vous dans votre espace SPIADI pour vous inscrire et
                  gérer votre surveillance (saisie, gestion des membres,
                  charte ...).
                </p>
              </div>
              <div class="col-xs-6 col-sm-12 col-lg-8">
                <p>
                  <btn type="success"
                       block
                       @click="$router.push('/establishments/list')">
                    Mon espace SPIADI
                  </btn>
                </p>
              </div>
              <div class="col-xs-12">
                <p class="text-justify">
                  Les résultats et protocoles de la surveillance des années
                  précédentes sont accessibles sur la page «Résultats».
                </p>
              </div>
              <div class="col-xs-6 col-sm-12 col-lg-8">
                <p>
                  <btn type="warning"
                       block
                       @click="$router.push('/results')">
                    Résultats
                  </btn>
                </p>
              </div>
            </div>
          </home-panel>
        </div>
        <div class="col-xs-12 col-md-6 col-lg-4" id="observation-panel">
          <home-panel :background="require('@/assets/demo.jpg')">
            <div class="row">
              <div class="col-xs-12">
                <h3><p>Observation des pratiques</p></h3>
                <p class="text-justify">
                  Trois modules sont proposés pour 2026 :
                  <ul>
                    <li>
                      <strong>OBSERVA4</strong><br />
                      Observation des pratiques concernant la pose et la
                      manipulation des cathéters.
                    </li>
                    <li>
                      <strong>RÉA expl AUR</strong><br />
                      <i>S. aureus</i> et prévention des bactériémies liées
                      aux dispositifs invasifs dans les services de réanimation.
                    </li>
                    <li>
                      <strong>SPY4</strong><br />
                      Étude un jour donné de la prévalence du port des cathéters et
                      de l'utilisation des MIDlines et des CVPs courts.
                    </li>
                  </ul>
                </p>
              </div>
              <div class="col-xs-6 col-sm-12 col-lg-8">
                <p>
                  <btn type="primary"
                       block
                       @click="$router.push('/program?target=observation')">
                    En savoir plus
                  </btn>
                </p>
              </div>
              <div class="col-xs-12">
                <p class="text-justify">
                  Rendez vous dans votre espace SPIADI pour la présentation des
                  protocoles, vous inscrire et gérer vos enquêtes
                  (saisie, gestion des membres, charte ...).
                </p>
              </div>
              <div class="col-xs-6 col-sm-12 col-lg-8">
                <p>
                  <btn type="success"
                       block
                       @click="$router.push('/establishments/list')">
                    Mon espace SPIADI
                  </btn>
                </p>
              </div>
              <div class="col-xs-12">
                <p class="text-justify">
                  Les résultats et protocoles des années précédentes sont accessibles sur la page
                  «Résultats».
                </p>
              </div>
              <div class="col-xs-6 col-sm-12 col-lg-8">
                <p>
                  <btn type="warning"
                       block
                       @click="$router.push('/results')">
                    Résultats
                  </btn>
                </p>
              </div>
            </div>
          </home-panel>
        </div>
        <div class="col-xs-12 col-md-6 col-lg-4">
          <home-panel :background="require('@/assets/img/missionday/2019/02.jpg')">
            <div class="row">
              <div class="col-xs-12">
                <h3>Formation</h3>
                <p class="text-justify">
                  Le 13&nbsp;Octobre&nbsp;2026 s'est tenue la huitième
                  <strong>Journée Nationale de la mission SPIADI</strong> sur le thème :
                </p>
                <p>
                  <i>
                    Prévention des infections associées aux dispositifs invasifs :
                    cap sur l’avenir !
                  </i>
                </p>
                <p class="text-justify">
                  Vous trouverez sur cette page quelques photos de la journée,
                  ainsi que les diaporamas des interventions.
                </p>
              </div>
              <div class="col-xs-6 col-sm-12 col-lg-8">
                <p>
                  <btn type="primary" block @click="$router.push('/missionday?tab=0')">
                    En savoir plus
                  </btn>
                </p>
              </div>
              <div v-if="displaySaveTheDateForMissionDay" class="col-xs-12">
                <alert type="warning" class="text-justify">
                  <h4>
                    <span class="glyphicon glyphicon-calendar info"></span>
                    Réservez la date !
                  </h4>
                  La prochaine Journée Nationale de la mission SPIADI
                  se tiendra le <strong>13&nbsp;Octobre&nbsp;2026</strong>.
                </alert>
              </div>

              <div class="col-xs-12">
                <hr/>
                <h3>Valorisation</h3>
                <p class="text-justify">
                  <strong>
                    Valoriser les travaux de la SPIADI est une priorité. Nos
                    travaux font l'objet de communications et de publications.
                  </strong>
                </p>
              </div>
              <div class="col-xs-6 col-sm-12 col-lg-8">
                <p>
                  <btn type="default"
                       block
                       @click="$router.push('/valuation')">
                    Accéder à la section
                  </btn>
                </p>
              </div>
            </div>
          </home-panel>
        </div>
      </div>
    </page-section>
  </div>
</template>

<script>
import pageSection from '@/components/pagesection'
import homePanel from '@/components/homepanel'
import { mapState } from 'vuex'

export default {
  name: 'home',

  data () {
    return {
      displaySaveTheDateForMissionDay: false
    }
  },

  computed: {
    ...mapState({
      sc: state => state.cloud.cfg.presentation
    })
  },

  components: {
    homePanel,
    pageSection
  }
}
</script>

<style scoped lang="less">
@import "~variables";

.home-panel {
  .col-xs-12:first-child {
    h3:first-child {
      margin-top: 0px;
    }
  }

  h3, h4 {
    color: @dark-base;
  }

  .alert {
    .glyphicon-calendar {
      color: @brand-primary;
    }
  }
}

ul {
  padding-left: 1.2rem;
}

#observation-panel ul {
  margin-top: 1rem;
  li {
    margin-top: 1rem;
  }
}
.home-carousel {
  margin-top: 2rem;
  margin-bottom: 5rem;
  .img-container {
    max-width: 1500px;
    margin: auto;
    border-radius: 1rem;
    overflow: hidden;
  }
}

.carousel-caption {
  right: 18%;
  max-width: 680px;
  margin-left: auto;
  padding: 2rem;
  background-color: rgba(255, 255, 255, 0.85);
  bottom: 6%;
  border-radius: 1rem;
  color: @base-text;
  text-shadow: none;

  h3 {
    color: @dark-base;
    margin-top: 0rem;
  }

  li {
    list-style: circle;
  }

  @media (min-width: 0) and (max-width: @screen-sm-max) {
    position: initial;
    border-radius: 0rem;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: @screen-md-min) and (max-width: @screen-md-max) {
    left: 12%;
    right: 12%;
    bottom: 5%;
    margin-left: auto;
    margin-right: auto;
    max-width: 700px;
  }
}

.carousel-indicators-container {
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: -3rem;
  width: 100%;
  margin-bottom: 0px;
}

.custom-carousel-indicators {
  position: initial;
  margin-left: 0rem;
  width: auto;
  border-radius: 1rem;
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 0.02rem;
  padding-bottom: 0.02rem;
  margin-bottom: 0px;

  li {
    border-color: @brand-primary;
    color: @brand-primary;
    border-radius: 0.2rem;
    margin: 0rem 0.3rem;
    width: 3rem;
    height: 2.2rem;
    text-indent: 0px;
  }

  li.active {
    background-color: @brand-primary;
    color: white;
  }
}

.home-panels {
    background-color: @dark-base;
}
</style>
<style lang="less">
@import "~variables";

.home-carousel {
  .carousel-control,
  .img-responsive {
    border-radius: 1rem;
  }

  .carousel-control {
    width: 5%;
    background: none;

    .glyphicon {
      width: auto;
    }

    .glyphicon:before {
      padding: 1rem 1.2rem;
      border-radius: 100%;
      background-color: @brand-primary;

    }
  }

  .actu-date {
    width: 9rem;
    text-align: center;
    border-radius: 0.4rem;
    display: inline-block;
    margin-right: 0.2rem;
    margin-bottom: 0.2rem;
    @media (min-width: 0) and (max-width: @screen-xs-max) {
      display: block;
    }
  }

  .actu-indent{
    margin-left: 9rem;
    padding-left: 0.4rem;
  }
}
</style>
